import { Component, OnInit, inject } from '@angular/core';
import { FormNavigationService } from '../../../../services/form-navigation/form-navigation.service';
import { NavigationKey } from '../../../../enums/navigation-key-type';

@Component({
  selector: 'app-witness-information-redirect',
  template: '<div>Redirecting...</div>',
  standalone: true
})
export class WitnessInformationRedirectComponent implements OnInit {
  private formNavigationService = inject(FormNavigationService);

  ngOnInit() {
    // Immediately redirect to the appropriate next step
    this.formNavigationService.navigate(NavigationKey['witness-information']);
  }
}